export enum HubPackageStatus {
  Error = "error",
  Ready = "ready",
  Installed = "installed",
}
